export default __webpack_public_path__ + "static/media/ke.3e275fad.svg";